import { FB_FUNCTIONS_URL } from '../shared/constants';

export class ZoomService {
  static async getUserTokens(code) {
    try {
      const tokens = await fetch(`${FB_FUNCTIONS_URL}/zoom/auth?code=${code}`).then(res =>
        res.json()
      );
      return tokens;
    } catch (err) {
      return null;
    }
  }

  static async createMeeting(code, startTime, duration, topic) {
    const body = {
      code: code,
      startTime: startTime,
      duration: duration,
      topic: topic
    };

    try {
      const meeting = await fetch(`${FB_FUNCTIONS_URL}/zoom/meeting`, {
        method: 'POST',
        body: JSON.stringify(body)
      }).then(res => res.json());
      return meeting;
    } catch (err) {
      return null;
    }
  }

  static async getMeetings(accessToken) {
    try {
      const meetings = await fetch(`${FB_FUNCTIONS_URL}/zoom/meeting`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` }
      }).then(res => res.json());
      return meetings;
    } catch (err) {
      return null;
    }
  }
}
